module.exports = __webpack_public_path__ + "img/dingning.0eca1f91.jpg";